import styled, { css } from 'styled-components';
import { Sizes, Directions, Alignments } from '@sede-x/shell-ds-react-base';

import { getColorBySentiment } from '../../utils/colorUtils';
import Heading from '../Text/components/Heading/Heading';
import { IHeadingProps } from '../Text/components/Heading/Heading.types';
import Text from '../Text/components/Text/Text';
import { TextSize } from '../Text/components/Text/Text.types';
import { EmptyStateIconSentiment, EmptyStateSize, IEmptyStateProps } from './EmptyState.types';
import { emptyStateConsts } from './EmptyState.consts';
import { Sentiments } from '../../types/types';

const EmptyState = styled.div<Required<Pick<IEmptyStateProps, 'size'>>>`
  ${({ size }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: ${emptyStateConsts[size].gap}px;
    padding: ${size === Sizes.Large ? '32px' : '16px'};
  `}
`;

const VisualPlaceholder = styled.div<
  Required<Pick<IEmptyStateProps, 'size'>> & {
    iconSentiment?: EmptyStateIconSentiment;
    type: 'icon' | 'pictogram' | 'image' | 'none';
  }
>`
  ${({ size, iconSentiment, type, theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;

    ${type === 'image' &&
    css`
      img {
        width: ${emptyStateConsts[size].image}px;
        height: ${emptyStateConsts[size].image}px;
      }
    `}

    ${(type === 'icon' || type === 'pictogram') &&
    css`
      svg {
        width: ${emptyStateConsts[size][type]}px;
        height: ${emptyStateConsts[size][type]}px;

        ${type === 'icon' &&
        iconSentiment &&
        css`
          fill: ${iconSentiment === Sentiments.Warning
            ? theme.text.onSurface.warning
            : getColorBySentiment(iconSentiment, theme)};
        `}
      }
    `}
  `}
`;

const TextPlaceholder = styled.div<Required<Pick<IEmptyStateProps, 'size'>>>`
  ${({ size }) => css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: ${emptyStateConsts[size].textGap}px;
  `}
`;

const Title = styled(Heading)<IHeadingProps & { size: EmptyStateSize }>`
  max-width: 480px;
  text-align: center;
`;

const Description = styled(Text)<{ size: TextSize }>`
  max-width: 480px;
  text-align: center;
`;

const Actions = styled.div<
  Required<Pick<IEmptyStateProps, 'size'>> & Pick<IEmptyStateProps, 'actionsDirection' | 'actionsAlignment'>
>`
  ${({ size, actionsDirection, actionsAlignment }) => css`
    display: flex;
    gap: ${emptyStateConsts[size].actionsGap}px;
    flex-direction: ${actionsDirection === Directions.Horizontal ? 'row' : 'column-reverse'};

    ${(actionsAlignment === Alignments.Fill || actionsDirection === Directions.Vertical) &&
    css`
      width: 100%;
      justify-content: space-between;
    `}
  `}
`;

export { EmptyState, VisualPlaceholder, TextPlaceholder, Title, Description, Actions };
